import * as React from 'react'
import { TouchableOpacity, Text } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Icon from '@components/icon/Icons'

type SelectStyle = 'default' | 'empty' | 'bold'

interface Props {
  label: string
  onClick: () => void
  icon?: IconName
  left?: boolean
  disabled?: boolean
  focused?: boolean
  selectStyle?: SelectStyle
}

const Select = ({ label, icon, onClick, left, disabled, focused, selectStyle = 'default' }: Props) => {
  return (
    <Container activeOpacity={0.9} onPress={onClick} disabled={disabled} focused={focused} selectStyle={selectStyle}>
      {left && !!icon && <Icon name={icon} size={20} color={theme.colors.primary} />}
      <Label left={left} focused={focused} selectStyle={selectStyle}>
        {label}
      </Label>
      {!left && !!icon && <Icon name={icon} size={20} color={theme.colors.primary} />}
    </Container>
  )
}

export default Select

const Container = styled(TouchableOpacity)<{ selectStyle: SelectStyle; focused?: boolean }>`
  flex-direction: row;
  align-items: center;
  padding: 24px 20px;
  border-radius: ${(props) => (props.selectStyle === 'bold' ? 0 : 8)}px;
  background-color: ${(props) => (props.selectStyle === 'empty' ? 'transparent' : props.theme.colors.secondaryActive)};
  border: ${(props) => (props.focused ? 2 : props.selectStyle === 'empty' ? 1 : 0)}px solid
    ${(props) => (props.selectStyle === 'empty' ? props.theme.colors.secondaryActive : props.theme.colors.primary)};
`

const Label = styled(Text)<{ selectStyle: SelectStyle; left?: boolean; focused?: boolean }>`
  ${(props) => (props.selectStyle === 'bold' ? props.theme.fonts.Headline : props.theme.fonts.Body)};
  font-weight: ${(props) => (props.focused ? 'bold' : 400)};
  color: ${(props) => (props.selectStyle === 'default' ? props.theme.colors.primary : props.theme.colors.primaryText)};
  flex: 1;
  margin-left: ${(props) => (props.left ? 15 : 0)}px;
`
